import { Component } from '@angular/core';
import  *  as  navigationData  from  './dashboard-navigation.json';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent {
  public navigation = (navigationData as any).default;

  constructor() { }
}
